import { Type } from 'class-transformer';
import { IsEnum, IsNotEmpty, IsNumber, IsOptional, IsString } from 'class-validator';
import { CityInfoDto } from './geo/city';
import { MediaTypeBaseDataDto } from './media-type.dto';
import { CountryInfoDto, MediaCommerceDto, MediaPlacementType, RegionInfoDto } from '../main';

export class CreateMediaDto {
  @IsNumber()
    typeId: number;

  cityId?: number | null;

  regionId?: number | null;

  countryId?: number | null;

  parentMediaId?: number | null;

  @IsString()
  @IsNotEmpty()
    name: string;

  @IsEnum(MediaPlacementType)
    placement: MediaPlacementType;
}

export class UpdateMediaBasicDto {
  id: number;

  @IsString()
  @IsNotEmpty()
    name: string;

  @IsNumber()
    typeId: number;

  cityId?: number | null;

  regionId?: number | null;

  countryId?: number | null;

  parentMediaId?: number | null;

  @IsOptional()
  @IsEnum(MediaPlacementType)
    placement?: MediaPlacementType | null;

  @IsOptional()
  @IsNumber()
    publishingDataId?: number;
}

export class MediaBasicDataDto {
  id: number;
  name: string;
  mediaType: MediaTypeBaseDataDto;
  city: CityInfoDto;
  region: RegionInfoDto;
  country: CountryInfoDto;
  cityId: number | null;
  regionId: number | null;
  countryId: number | null;
  parentMediaId: number | null;
  childrenMedia: MediaBasicDataDto[];
  placement: MediaPlacementType | null;
  parentMedia: MediaBasicDataDto;
  publishingDataId: number | null;
  mediaCommerce: MediaCommerceDto[];
}

export class MediaInfoDto {
  id: number;

  @IsString()
  @IsNotEmpty()
    name: string;

  city: CityInfoDto | null;
  region: RegionInfoDto | null;
  country: CountryInfoDto | null;
  parentMedia: MediaInfoDto | null;
  @IsEnum(MediaPlacementType)
    placement: MediaPlacementType | null;
  childrenMedia: MediaBasicDataDto[];

  @Type(() => MediaTypeBaseDataDto)
    mediaType: MediaTypeBaseDataDto;
    
  mediaCommerce: MediaCommerceDto[];
}

export class CreateMediaChildrenDataDto {
  regions: number[];
  cities: number[];
  media: MediaBasicDataDto;
}
